import React, { useEffect } from "react"

const colors = {
  dark: "#000E58",
  light: "#f2f6ff"
}

const PercentageBar = ({ percentage, children, theme, style = {} }) => {
  if (React.isValidElement(children) && children.type === "tr") {
    const className = `percentage-bar-row-${percentage}`

    useEffect(() => {
      const styleId = `percentage-bar-styles-${className}`
      let styleElement = document.getElementById(styleId)

      if (!styleElement) {
        styleElement = document.createElement("style")
        styleElement.id = styleId
        document.head.appendChild(styleElement)
      }

      styleElement.textContent = `
        .${className} {
          position: relative !important;
          background-image: linear-gradient(to right, ${colors?.[theme]} ${percentage}%, transparent ${percentage}%) !important;
          background-size: 100% 100% !important;
          background-repeat: no-repeat !important;
        }
      `

      return () => {
        if (styleElement && styleElement.parentNode) {
          styleElement.parentNode.removeChild(styleElement)
        }
      }
    }, [percentage, className])

    return React.cloneElement(children, {
      className: `without-bg-sort ${children.props.className || ""} ${className}`.trim(),
      style: {
        ...children.props.style,
        ...style
      }
    })
  }

  // Fallback for other cases
  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        minHeight: "55px",
        display: "flex",
        alignItems: "center",
        ...style
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          height: "100%",
          width: `${percentage}%`,
          backgroundColor: "#f2f6ff",
          zIndex: 0,
          borderRadius: "0px"
        }}
      />

      <div style={{ position: "relative", zIndex: 1, width: "100%" }}>{children}</div>
    </div>
  )
}

export default PercentageBar
